import * as z from 'zod';

import { urlSchema } from '@/_schemas/generic';
import { statusFormSchema } from '@/_schemas/status-input';

import { magazineQuerySchema } from './magazine-query-schema';

export const magazineFormSchema = magazineQuerySchema
  .omit({ name: true, status: true, website: true, clients_count: true })
  .extend({
    name: z.string().min(3),
    status: statusFormSchema,
    website: urlSchema(),
  });
export type MagazineFormSchema = z.infer<typeof magazineFormSchema>;
